import React, { useState } from 'react'; // NEW: Import useState
import { UnitOfMeasure } from '../types/costwand.d';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table.tsx';
import { Button } from './ui/button.tsx';
import Pagination from './ui/Pagination.tsx';
import { Spinner } from './ui/spinner.tsx';
import { apiClient } from '../api/apiClient.ts'; // NEW: Import apiClient

interface UnitOfMeasureTableProps {
  unitsOfMeasure: UnitOfMeasure[];
  currentPage: number;
  totalPages: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  onEdit: (unitOfMeasure: UnitOfMeasure) => void;
  onDelete: (id: number) => void;
  loading: boolean;
  error: string | null;
  baseEndpoint: string; // NEW: Add baseEndpoint prop
}

const UnitOfMeasureTable: React.FC<UnitOfMeasureTableProps> = ({
  unitsOfMeasure,
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
  onEdit,
  onDelete,
  loading,
  error,
  baseEndpoint, // NEW: Destructure baseEndpoint
}) => {
  const [exportLoading, setExportLoading] = useState(false); // NEW: State for export loading

  const handleExportCsv = async () => {
    setExportLoading(true);
    try {
      await apiClient<void>(baseEndpoint, { downloadCsv: true });
    } catch (err: any) {
      // Error already handled by apiClient and globalErrorHandler
    } finally {
      setExportLoading(false);
    }
  };

  if (loading) return <p className="text-center text-muted-foreground flex items-center justify-center gap-2"><Spinner size="sm" /> Loading units of measure...</p>;
  if (error) return <p className="text-center text-destructive">Error: {error}</p>;
  if (unitsOfMeasure.length === 0 && !loading) return <p className="text-center text-muted-foreground">No units of measure found.</p>;

  return (
    <div className="rounded-md border">
      <div className="flex justify-end mb-4"> {/* NEW: Wrapper for export button */}
        <Button onClick={handleExportCsv} disabled={loading || exportLoading} variant="outline">
          {exportLoading ? <span className="flex items-center gap-2"><Spinner size="sm" /> Exporting...</span> : 'Export to CSV'}
        </Button>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Units</TableHead>
            <TableHead>Is Package</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {unitsOfMeasure.map((unit) => (
            <TableRow key={unit.id}>
              <TableCell className="font-medium">{unit.name}</TableCell>
              <TableCell>{unit.units}</TableCell>
              <TableCell>{unit.is_package === 1 ? 'Yes' : 'No'}</TableCell>
              <TableCell className="flex justify-end gap-2">
                <Button variant="outline" size="sm" onClick={() => onEdit(unit)}>Edit</Button>
                <Button variant="destructive" size="sm" onClick={() => onDelete(unit.id!)}>Delete</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default UnitOfMeasureTable;